import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import PathologiesHumidite from "@/pages/PathologiesHumidite";
import EnduitsChauxPlatreArgile from "@/pages/EnduitsChauxPlatreArgile";
import PeinturesDecorativesBatiAncien from "@/pages/PeinturesDecorativesBatiAncien";

function App() {
    return (
        <div className="App font-body">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/mentions-legales" element={<MentionsLegales />} />
                    <Route path="/confidentialite" element={<Confidentialite />} />
                    <Route path="/pathologies-humidite" element={<PathologiesHumidite />} />
                    <Route path="/enduits-chaux-platre-argile" element={<EnduitsChauxPlatreArgile />} />
                    <Route path="/peintures-decoratives-bati-ancien" element={<PeinturesDecorativesBatiAncien />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
